import { useDsModalVideoTools } from "@sazka/design-system/src/modal-video/use-ds-modal-video-tools";
import { WebpHelper } from "@sazka/utils/webp-helper";
import { ArticleResponseModel, CasinoArticleResponse } from "../our-office/articles-model";
import { useDayjs } from "@sazka/utils/dayjs";

const { dayjs } = useDayjs();

$(() => {
    const root = $("#casino-related-articles");
    if (!root.length) {
        return;
    }

    (function (root) {
        const articleType = environment.nodeAliasPath.indexOf("/losy/") == 0 ? "losy" : "hry";

        loadArticles();

        function loadArticles() {
            $.ajax({
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: "/api/casino-article",
                data: JSON.stringify({
                    tag: getTag(),
                    pageSize: 6,
                    page: 1,
                    articleType: articleType,
                    not: environment.nodeId.toString(),
                }),
                success: loadSuccess,
                error: loadError,
            });
        }

        function loadSuccess(response: CasinoArticleResponse) {
            if (response.casinoArticles) {
                root.html(fillSlots(response.casinoArticles));
            }
        }

        function fillSlots(articleList: ArticleResponseModel[]) {
            let resultHtml = "";
            const rowSize = getSpacePerRow();
            let remainingRowSpace = rowSize;

            while (articleList.length && remainingRowSpace > 0) {
                const item = articleList.shift();
                remainingRowSpace--;
                resultHtml += markup(item);
            }

            return resultHtml;
        }

        function getSpacePerRow() {
            if (window.matchMedia("(min-width: 2121px)").matches) {
                //xl
                return 6;
            } else if (window.matchMedia("(min-width: 1631px)").matches) {
                //1920
                return 5;
            } else if (window.matchMedia("(min-width: 1221px)").matches) {
                //1280
                return 4;
            } else if (window.matchMedia("(min-width: 897px)").matches) {
                // sm2
                return 3;
            } else {
                return 2;
            }
        }

        function loadError() {
            root.text("Omlouváme se, ale došlo k problému při načítání článku. Zkuste to prosím později.");
        }

        function markup(item: ArticleResponseModel) {
            return item.cardType == "video"
                ? `
                <div class="casino-article-preview casino-article-preview--${item.cardType} casino-article-preview--${
                      item.cardVertical
                  }" >
                    <a href="${
                        useDsModalVideoTools(item.videoCodes[0]).embedVideoUrl
                    }" class="content btn-video" data-video-codes="${item.videoCodes.join("|||")}">
                        ${
                            item.cardVertical != "losy"
                                ? `<span class="card-tag"><span class="tag-inner">${item.tag}</span></span>`
                                : ""
                        }
                        <div class="inner">
                            ${WebpHelper.createPictureTag(item.imageUrl || item.gameImageUrl, item.name, "image")}
                            <div class="article-content">${item.name}</div>
                            <div class="play-button btn btn-primary ico-a-play-empty"></div>
                        </div>
                    </a>
                </div>`
                : `<div class="casino-article-preview casino-article-preview--${
                      item.cardType
                  } casino-article-preview--${item.cardVertical}">
                    <a href="${item.url}" class="content">
                        <span class="card-tag">
                            <span class="tag-inner">${
                                item.cardVertical == "losy" ? dayjs(item.date).format("D. M. YYYY") : item.tag
                            }</span>
                        </span>
                        <div class="inner">
                        ${((item) => {
                            if (item.imageUrl || item.gameImageUrl) {
                                return WebpHelper.createPictureTag(
                                    item.imageUrl || item.gameImageUrl,
                                    item.name,
                                    "image"
                                );
                            } else {
                                return "<img class='image' />";
                            }
                        })(item)}
                        ${
                            item.autor
                                ? `<span class="author">
                                    ${WebpHelper.createPictureTag(item.autor.image, item.autor.name)}
                                    ${item.autor.name},
                                    ${dayjs(item.date).format("D. M. YYYY")}
                                </span>`
                                : ""
                        }
                            <div class="article-content">${item.name}</div>
                        </div>
                    </a>
                </div>`;
        }

        function getTag() {
            try {
                const tagText = $("#casino-related-articles").data("tag");
                if (tagText) {
                    return tagText.split(",").map((x) => {
                        x = x.trim();
                        if (x[0] == '"') {
                            x = x.substring(1);
                        }
                        if (x[x.length - 1] == '"') {
                            x = x.substring(0, x.length - 1);
                        }
                        return x;
                    })[0];
                }
                return null;
            } catch {
                return null;
            }
        }
    })(root);
});
